module.exports = __webpack_public_path__ + "img/icon_c.079ccc68.png";